import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum WorkflowFields {
    NAME = 'name',
    TYPE = 'type',
    IS_PAUSED = 'isPaused',
}

export namespace WorkflowFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<WorkflowFields, Data> = {
        [WorkflowFields.NAME]: {
            text: 'Name',
        },
        [WorkflowFields.TYPE]: {
            text: 'Typ',
            readOnly: true,
        },
        [WorkflowFields.IS_PAUSED]: {
            text: 'Ist pausiert?',
        },
    };

    export const Items = mapRecordToItems(Record);
}
